export default "__VITE_ASSET__DhW2s$HI__"